import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  products: [],
  product: null,
};

const setProducts = (state, action) => (
  updateObject(state, {
    products: action.products,
  })
);

const setProduct = (state, action) => (
  updateObject(state, {
    product: action.product,
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_PRODUCTS]: setProducts,
  [actionType.SET_PRODUCT]: setProduct,
});

export default reducer;

// SELECTORS
export const getProducts = (state) => state.products;
export const getProduct = (state) => state.product;
